import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";

export const SUPPORTED_LOCALES = ["es", "en", "fr", "it"];
export const DEFAULT_LOCALE = "es";
const STORAGE_KEY = "atlas.locale";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      fr: { translation: fr },
      it: { translation: it },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    // "es-ES" y "es-AR" comparten catálogo: solo interesa el idioma base.
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

/** Cambia el idioma y lo refleja en el atributo `lang` del documento. */
export function changeLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  i18n.changeLanguage(locale);
  document.documentElement.lang = locale;
}

i18n.on("languageChanged", (locale) => {
  document.documentElement.lang = locale.split("-")[0];
});

export default i18n;
